// extracted by mini-css-extract-plugin
export default {"container":"About_styles_container__RA5--"};